import { render, staticRenderFns } from "./AlumnoLogIn.vue?vue&type=template&id=4d865928&"
import script from "./AlumnoLogIn.vue?vue&type=script&lang=js&"
export * from "./AlumnoLogIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports